export default __webpack_public_path__ + "static/wp-back-270a0f37ff4443feb7c2621e58f4b8f2.png";